<template>
  <section class="photo-grid-wrapper">
    <div class="photo-grid-feature" ref="feature" v-html="feature" @click="openModal" role="button" tabindex="0" aria-label="product photo" />
    <div class="photo-grid">
      <slot></slot>
    </div>
  </section>
</template>

<script>
export default {
  name: "photos",

  props: ["feature"],

  data() {
    return {
      photos: []
    };
  },

  created() {
    this.photos = this.$children;
  },

  mounted() {
    this.setInitialFeature();
  },

  methods: {
    setInitialFeature() {
      return (this.$refs.feature.innerHTML = this.$children[0].$el.innerHTML);
    },

    openModal() {
      this.$emit('openModal');
    }
  }
};
</script>

<style lang="scss">
.photo-grid-wrapper {
  background-color: white;
  box-shadow: 0px 0px 12px -3px rgba(0, 0, 0, 0.38);
  padding: 10px;
  max-width: 630px;
  margin: 30px auto;
}

.photo-grid-feature {
  position: relative;
}

.photo-grid-feature img {
  width: 100%;
  display: block;
}

.photo-grid-feature span {
  position: absolute;
  bottom: 7px;
  left: 18px;
  background-color: rgba(255, 255, 255, 0.85);
  font-family: var(--roboto);
  font-size: 0.875rem;
  line-height: 1.214;
  color: var(--black);
  text-align: center;
  padding: 5px 5%;
}

.photo-grid {
  display: none;
}

.photo-grid-feature .btn-wrapper {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 93px !important;
  height: 93px !important;
  border-radius: 47px !important;
  border: 4px solid var(--white);
  cursor: pointer;
}

.photo-grid-feature .btn-wrapper::after {
  content: "";
  width: 0;
  height: 0;
  font-size: 0;
  line-height: 0;
  border-top: 16px solid transparent !important;
  border-left: 24px solid #fff !important;
  border-bottom: 16px solid transparent !important;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-30%, -50%);
}

@media only screen and (min-width: 600px) {
  .photo-grid-feature span {
    left: 18px;
    bottom: 18px;
    transform: translateX(0);
    padding: 10px 40px;
  }
}

@media only screen and (min-width: 768px) {
  .photo-grid-wrapper {
    max-width: 530px;
  }
}

@media only screen and (min-width: 1024px) {
  .photo-grid-wrapper {
    max-width: 460px;
    margin-right: 25px;
    align-self: start;
  }
}
</style>